import { EMPLOYEE_ASSIGNMENT_HISTORY_ERROR_LABELS } from 'pages/departmentAssignmentHistory/model/departmentAssignmentHistory';
import type { Task } from 'types/interfaces';
import type { TaskAssignmentRouteError } from 'types/interfaces/TaskAssignmentResult';

const TASK_NOT_ASSIGNED_MESSAGE = 'Для наряда не нашлось работников';
const TASK_WRONG_COORDINATES_MESSAGE = 'У наряда нет координат';

export const ASSIGNMENT_ERROR_MESSAGES: Record<string, string> = {
  employeeNotFound: 'Не найдено ни одного работника',
  notEnoughEmployees: 'Найдено меньше работников, чем требуется',
  departmentWithoutEmployees: 'В участке нет работников',
  taskTypeError: 'Не указан тип наряда',
  taskZeroEmployeeCount: 'В типе наряда не указано количество работников',
  taskStartError: 'Не указано плановое начало',
  taskFinishError: 'Не указано плановое завершение',
  taskNotFound: 'Наряд с таким идентификатором не найден',
  planningAlgorithmError: 'В типе наряда не задан алгоритм распределения',
  // Ошибки распределения с учетом времени доезда
  taskNotAssigned: TASK_NOT_ASSIGNED_MESSAGE,
  taskWrongCoordinates: TASK_WRONG_COORDINATES_MESSAGE
};

const NUMERIC_ERROR_MESSAGES: Record<string, string> = {
  ...Object.fromEntries(
    Object.entries(EMPLOYEE_ASSIGNMENT_HISTORY_ERROR_LABELS)
  ),
  '9': TASK_NOT_ASSIGNED_MESSAGE,
  '10': TASK_WRONG_COORDINATES_MESSAGE
};

const MESSAGES_BY_NORMALIZED_KEY: Record<string, string> = Object.fromEntries(
  Object.entries({
    ...NUMERIC_ERROR_MESSAGES,
    ...ASSIGNMENT_ERROR_MESSAGES
  }).map(([code, text]): [string, string] => [code.toLowerCase(), text])
);

export const getAssignmentErrorMessage = (error: string): string =>
  MESSAGES_BY_NORMALIZED_KEY[String(error).toLowerCase()] || error;

export interface FailedTaskAssignmentRow {
  taskId: number;
  taskTypeLabel: string;
  errors: string[];
}

// В списке распределения taskType приходит строкой, в результатах распределения — объектом
function getTaskTypeLabel(task?: Task): string {
  const taskType: unknown = task?.taskType;
  if (typeof taskType === 'string') return taskType;
  if (taskType && typeof taskType === 'object') {
    const label = (taskType as { label?: unknown }).label;
    if (typeof label === 'string') return label;
  }
  return '';
}

export function buildFailedTaskAssignmentRows(
  routeErrors: TaskAssignmentRouteError[] | undefined,
  tasks: Task[]
): FailedTaskAssignmentRow[] {
  if (!routeErrors?.length) return [];

  const tasksById: Record<number, Task> = {};
  tasks.forEach((task) => {
    const id = Number(task.id);
    if (!isNaN(id)) tasksById[id] = task;
  });

  return routeErrors.map((entry) => ({
    taskId: entry.taskId,
    taskTypeLabel: getTaskTypeLabel(tasksById[Number(entry.taskId)]),
    errors: Array.isArray(entry.errors) ? entry.errors : []
  }));
}
